import React, { useEffect } from "react";
import { Provider } from "react-redux";
import { ParallaxProvider } from "react-scroll-parallax";
import store, { Persistor } from "./store/store";
import "react-responsive-modal/styles.css";
import { HashRouter as Router, } from "react-router-dom";
import AppRoutes from "./Routes/AppRoutes";
import ToastifyContainer from "./components/Toastify/ToastifyContainer";
import setAuthToken from "./Helpers/setAuthToken";
import { loadUser } from "./actions/authActions";
import { getLabelVersion } from "./actions/lableAction";
import { addChatByUser } from "./actions/firebaseAction";
import { PersistGate } from "redux-persist/integration/react";
import 'react-perfect-scrollbar/dist/css/styles.css';

if (localStorage.AppToken) {
  setAuthToken(localStorage.AppToken);
}

function App() {
  useEffect(() => {
    if (localStorage.AppToken) {
      store.dispatch(loadUser());
    }
    store.dispatch(getLabelVersion());
  }, []);

  const handleAddChat = async () => {
    if (localStorage.AppToken) {
      const chatresult = await store.dispatch(addChatByUser());
      localStorage.setItem("chatresultId", chatresult.data?.result?._id);
      window.location.href = `#/chat-view/${chatresult.data?.result?._id}`;
    } else {
      window.location.href = "#/chat-initialize";
    }
  };

  return (
    <Router>
      <Provider store={store}>
        <PersistGate loading={null} persistor={Persistor}>
          <ParallaxProvider>
            <ToastifyContainer />
            <AppRoutes />
            <div className="fixedbutton" onClick={handleAddChat}>
              <img src={"assets/icons/chatbubble.svg"} alt="" />
            </div>
          </ParallaxProvider>
        </PersistGate>
      </Provider>
    </Router>
  );
}

export default App;
